var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"viewer-images"},[_c('img',{attrs:{"alt":_vm.imageName,"src":_vm.imageUrl}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }